import { Exchange, mapExchange } from 'urql';
import * as Sentry from '@sentry/browser';

type Options = {
  complexityLimit: number;
};

const onLimitExceeded = (complexity: number, complexityLimit: number): void => {
  const message = `GQL Query complexity of ${complexity} exceeded limit of ${complexityLimit}.`;
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-alert -- this is intentional, and will only be called in development
    alert(message);
  } else {
    // eslint-disable-next-line no-console
    console.warn(message);
    Sentry.captureMessage(message);
  }
};

export const warnOnComplexQueriesExchange: (options: Options) => Exchange = ({
  complexityLimit,
}) => {
  return mapExchange({
    onResult: result => {
      if ('extensions' in result) {
        const complexity = result.extensions.complexity as number;
        if (complexity && complexity > complexityLimit) {
          onLimitExceeded(complexity, complexityLimit);
        }
      }
    },
  });
};
